import React, {Component} from 'react';
import OrderRow from './orderRow';

class Substitute extends Component {
  render() {
    const {substitute} = this.props;

    if (!substitute) {
      return null;
    }

    return (
      <OrderRow type='substitute' order={substitute} />
    );
  }
}


export default Substitute;
